import { useState } from 'react';
import { useTexts } from 'utils/useTexts';

const RecaptchaLogo = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTexts();

  return (
    <div className="iLendingCDX-recaptcha-container">
      <div
        className={`iLendingCDX-recaptcha-box ${isOpen ? 'open' : 'closed'}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="iLendingCDX-recaptcha-logo" />
        <div className="iLendingCDX-recaptcha-text-container">
          <span>
            {t('recaptcha.protectedBy')} <b>{t('recaptcha.recaptcha')}</b>
          </span>
          <span>
            <a
              href="https://www.google.com/intl/en/policies/privacy/"
              target="_blank"
              rel="noreferrer"
            >
              {t('recaptcha.privacy')}
            </a>{' '}
            -{' '}
            <a
              href="https://www.google.com/intl/en/policies/terms/"
              target="_blank"
              rel="noreferrer"
            >
              {t('recaptcha.terms')}
            </a>
          </span>
        </div>
      </div>
    </div>
  );
};

export default RecaptchaLogo;
